import { Star } from 'lucide-react';
import clsx from 'clsx';

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: 'sm' | 'md';
  className?: string;
}

export function StarRating({ rating, maxRating = 5, size = 'sm', className }: StarRatingProps) {
  const starSize = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <div
      role="img"
      aria-label={`${rating} out of ${maxRating} stars`}
      className={clsx('flex items-center gap-0.5', className)}
    >
      {Array.from({ length: maxRating }, (_, i) => (
        <Star
          key={i}
          className={clsx(
            starSize,
            i < rating ? 'fill-warning text-warning' : 'text-bg-tertiary',
          )}
        />
      ))}
    </div>
  );
}
